export default {
  userList:[],//获取用户列表
  plateList:[],//获取版块列表
  plateNames:[],//方便搜索 所有版块的id与名字
  plateUserPlateList:[],//版主看到的版块列表
  commonList:[],//获取评论列表
  plateUserCommonList:[],//版主看到的评论列表
  articleList:[],//获取文章列表
  plateUserArticleList:[],//版主看到的文章列表
  loginUser:{},//当前登录的用户信息

  userId:null, //记录当前登录的用户id
  isLogin:false,
  token:'',

  toPlateUser:[],//记录可以成为版主的用户
}



// WEBPACK FOOTER //
// ./src/store/state.js